import {PromptToRouteResult} from '../generalNavigationTool.types';

function promptToRouteResultFailure({
  reasoning,
  missingInfo,
}: {
  reasoning: string;
  missingInfo: string;
}): PromptToRouteResult {
  return {
    success: false,
    reasoning,
    missingInfo,
    routeKey: null,
    pathParamValues: {},
    queryParamValues: {},
    confidence: 0,
  };
}

export default promptToRouteResultFailure;
